import React, { useState, useEffect, useContext } from 'react';
import { Typography } from 'antd';
import PatientSelectorPanel from '../patient/PatientSelectorPanel';
import RecordingNotesSection from './RecordingNotesSection';
import PatientForm from '../patient/PatientForm';
import FileUploadSection from './FileUploadSection';
import RecordingContext from './RecordingContext';

const { Text } = Typography;

export default function VisitModalContent({
  initialPatient = null,
  sessionUuid,
  fromPatientDetails = false,
  fromQuickEntry = false,
  children,
  onPatientChange
}) {
  const [selectedPatient, setSelectedPatient] = useState(initialPatient);
  const [isPatientModalOpen, setIsPatientModalOpen] = useState(false);
  const [editingPatient, setEditingPatient] = useState(null);
  const ctx = useContext(RecordingContext);
  
  // Use sessionUuid from context if available, otherwise use the prop
  const effectiveSessionUuid = ctx.sessionUuid || sessionUuid;

  const handlePatientChange = (patient) => {
    setSelectedPatient(patient);
    onPatientChange?.(patient);
  };

  // Handle document changes
  const handleDocumentsChange = (files) => {
    ctx.setAttachedDocuments(files);
  };

  // Clone children and pass selectedPatient prop
  const childrenWithProps = React.Children.map(children, child => {
    if (React.isValidElement(child) && typeof child.type === 'function') {
      return React.cloneElement(child, { selectedPatient });
    }
    return child;
  });

  return (
    <div style={{ padding: 16 }}>
      <PatientSelectorPanel
        selectedPatient={selectedPatient}
        fromPatientDetails={fromPatientDetails}
        onSelect={handlePatientChange}
        onAddPatient={() => {
          setEditingPatient(null);
          setIsPatientModalOpen(true);
        }}
        onEditPatient={() => {
          setEditingPatient(selectedPatient);
          setIsPatientModalOpen(true);
        }}
        onUnlinkPatient={() => handlePatientChange(null)}
      />


      {/* Document upload section */}
      <FileUploadSection
        onChange={handleDocumentsChange}
        attachedFiles={ctx.attachedDocuments}
        selectedPatient={selectedPatient}
      />

      <RecordingNotesSection 
        sessionUuid={effectiveSessionUuid}
        onPatientChange={handlePatientChange}
        fromQuickEntry={fromQuickEntry}
      />

      {/* Custom content passed as children with selectedPatient prop */}
      {childrenWithProps}

      <PatientForm
        isOpen={isPatientModalOpen}
        editingPatient={editingPatient}
        onCancel={() => {
          setIsPatientModalOpen(false);
          setEditingPatient(null);
        }}
        onSave={(savedPatient) => {
          handlePatientChange(savedPatient);
          setIsPatientModalOpen(false);
          setEditingPatient(null);
        }}
      />
    </div>
  );
} 